{
  "dashboard": "Developer Dashboard",
  "projects": "Projects",
  "reports": "Reports",
  "credits": "Credits",
  "dashboard_page": {
    "title": "Project Developer Dashboard",
    "subtitle": "Manage your carbon credit projects and track submission progress",
    "stats": {
      "registered_projects": "Registered Projects",
      "pending_reviews": "Pending Reviews",
      "issued_credits": "Issued Credits",
      "total_revenue": "Total Revenue"
    },
    "quick_actions": {
      "title": "Quick Actions",
      "submit_pin": "Submit PIN",
      "submit_pin_desc": "Project Idea Note",
      "submit_pdd": "Submit PDD",
      "submit_pdd_desc": "Project Design Document",
      "upload_reports": "Upload Reports",
      "upload_reports_desc": "Monitoring & Verification",
      "browse_registry": "Browse Registry",
      "browse_registry_desc": "Explore Projects",
      "request_credits": "Request Credits",
      "request_credits_desc": "Credit Issuance",
      "legacy_registration": "Legacy Registration",
      "legacy_registration_desc": "Compliance Dossier",
      "view_projects": "View Projects",
      "view_projects_desc": "Manage Portfolio"
    },
    "recent_activity": {
      "title": "Recent Activity",
      "pin_submitted": "PIN submitted for Wind Farm Alpha",
      "pin_submitted_time": "2 hours ago",
      "pdd_approved": "PDD approved for Solar Project Beta",
      "pdd_approved_time": "1 day ago",
      "credits_issued": "Credits issued for Forest Conservation Gamma",
      "credits_issued_time": "3 days ago"
    },
    "project_pipeline": {
      "title": "Project Pipeline",
      "idea_stage": "Idea Stage",
      "design_stage": "Design Stage",
      "validation_stage": "Validation Stage",
      "implementation_stage": "Implementation Stage",
      "monitoring_stage": "Monitoring Stage"
    },
    "recent_projects": {
      "title": "Recent Projects",
      "view_all": "View All"
    },
    "pending_tasks": {
      "title": "Pending Tasks",
      "urgent": "Urgent",
      "doe_selection_required": "DOE Selection Required",
      "doe_selection_desc": "Wind Farm Alpha - Select DOE within 5 days",
      "monitoring_report_due": "Monitoring Report Due",
      "monitoring_report_desc": "Solar Park Beta - RMR submission required",
      "payment_pending": "Payment Pending",
      "payment_pending_desc": "PDD submission fee - $1,500.00"
    },
    "notifications": {
      "title": "Recent Notifications",
      "pin_review_completed": "PIN Review Completed",
      "pin_review_desc": "Wind Farm Alpha has been approved. You can now submit PDD.",
      "doe_assignment": "DOE Assignment",
      "doe_assignment_desc": "GreenAudit Ltd assigned as DOE for Solar Park Beta validation.",
      "system_maintenance": "System Maintenance",
      "system_maintenance_desc": "Scheduled maintenance on Dec 20, 2024 from 2:00-4:00 AM UTC.",
      "time_2_hours_ago": "2 hours ago",
      "time_1_day_ago": "1 day ago",
      "time_3_days_ago": "3 days ago"
    }
  },
  "browse_registry": {
    "title": "Registry Explorer",
    "subtitle": "Browse projects, track credits, and generate exportable reports",
    "export_report": "Export Report",
    "advanced_filter": "Advanced Filter",
    "search_placeholder": "Search projects...",
    "filters": {
      "all_categories": "All Categories",
      "all_status": "All Status",
      "all_proponents": "All Proponents",
      "article6_eligible": "Article 6 Eligible",
      "clear": "Clear"
    },
    "stats": {
      "total_projects": "Total Projects",
      "credits_issued": "Credits Issued",
      "credits_retired": "Credits Retired",
      "buffer_credits": "Buffer Credits",
      "active_transfers": "Active Transfers"
    },
    "projects_table": {
      "title": "Active Projects"
    },
    "credit_tracking": {
      "recent_transactions": {
        "title": "Recent Credit Transactions",
        "credits_issued": "Credits Issued",
        "credits_transferred": "Credits Transferred",
        "credits_retired": "Credits Retired"
      },
      "generate_reports": {
        "title": "Generate Reports"
      }
    }
  },
  "request_credits": {
    "title": "Carbon Credit Issuance",
    "subtitle": "Manage credit issuance requests, fee payments, and mandatory deductions",
    "new_issuance_request": "New Issuance Request",
    "credit_issuance_request": {
      "title": "Credit Issuance Request",
      "subtitle": "Submit verification documents for credit issuance",
      "project_name": "Project Name",
      "select_project": "Select Project",
      "certificate_registration": "Certificate of Registration",
      "monitoring_period_start": "Monitoring Period Start",
      "monitoring_period_end": "Monitoring Period End",
      "requested_credits": "Requested Credits for Issuance",
      "credits_placeholder": "Enter number of credits"
    },
    "required_documents": {
      "title": "Required Documents",
      "doe_verification": "DOE Verification Report",
      "monitoring_reports": "Monitoring Reports",
      "ics_certificates": "ICS Issuance Certificates (if applicable)",
      "legacy_projects_only": "For legacy projects only",
      "upload_pdf": "Upload PDF file (Max 10MB)",
      "upload_multiple": "Upload multiple files (Max 10MB each)",
      "choose_file": "Choose File",
      "choose_files": "Choose Files"
    },
    "issuance_summary": {
      "title": "Issuance Summary",
      "requested_credits": "Requested Credits",
      "mandatory_deductions": {
        "title": "Mandatory Deductions",
        "ndc_retirement": "NDC Retirement (1%)",
        "buffer_account": "Buffer Account (2%)",
        "transaction_account": "Transaction Account (30%)"
      },
      "net_credits": "Net Credits to Issue"
    },
    "fee_calculation": {
      "title": "Fee Calculation",
      "cci_certificate_fee": "CCI Certificate Fee",
      "credit_issuance_fee": "Credit Issuance Fee",
      "total_fee": "Total Fee",
      "proceed_payment": "Proceed to Payment"
    },
    "processing_timeline": {
      "title": "Processing Timeline",
      "message": "Credit issuance typically takes 5-7 business days after payment confirmation and document verification."
    },
    "recent_issuances": {
      "title": "Recent Issuance Requests",
      "columns": {
        "request_id": "Request ID",
        "project": "Project",
        "credits": "Credits",
        "fee": "Fee",
        "status": "Status",
        "date": "Date",
        "actions": "Actions"
      },
      "status": {
        "all": "All Status",
        "completed": "Completed",
        "processing": "Processing",
        "pending": "Pending",
        "rejected": "Rejected"
      }
    }
  },
  "register_page": {
    "title": "Project Developer Registration",
    "subtitle": "Complete your registration to submit projects and manage carbon credit lifecycle",
    "form_title": "Registration Form",
    "form_subtitle": "Please provide accurate information for verification",
    "registration_fee": "Registration Fee",
    "organization_info": {
      "title": "Organization Information",
      "legal_name": "Legal Entity Name",
      "legal_name_placeholder": "Enter your organization's legal name",
      "business_type": "Business Type",
      "select_type": "Select business type",
      "registration_number": "Registration Number",
      "registration_number_placeholder": "Business registration number",
      "country": "Country of Registration",
      "select_country": "Select country",
      "address": "Business Address",
      "address_placeholder": "Complete business address",
      "website": "Website",
      "website_placeholder": "https://www.example.com"
    },
    "contact_info": {
      "title": "Contact Information",
      "primary_contact": "Primary Contact Person",
      "primary_contact_placeholder": "Full name of primary contact",
      "job_title": "Job Title",
      "job_title_placeholder": "Position in organization",
      "email": "Email Address",
      "email_placeholder": "contact{'@'}example.com",
      "phone": "Phone Number",
      "phone_placeholder": "+1 (555) 123-4567",
      "alternative_contact": "Alternative Contact",
      "alternative_contact_placeholder": "Backup contact person"
    },
    "project_focus": {
      "title": "Project Focus Areas",
      "renewable_energy": "Renewable Energy",
      "renewable_energy_desc": "Solar, wind, hydro power projects",
      "energy_efficiency": "Energy Efficiency",
      "energy_efficiency_desc": "Building and industrial efficiency",
      "afolu": "AFOLU",
      "afolu_desc": "Agriculture, forestry, land use",
      "waste_management": "Waste Management",
      "waste_management_desc": "Waste treatment and disposal",
      "transport": "Transport",
      "transport_desc": "Sustainable transportation",
      "other": "Other",
      "other_desc": "Other carbon reduction activities"
    },
    "declarations": {
      "title": "Declarations & Compliance",
      "agree_terms": "I agree to the",
      "terms_conditions": "Terms and Conditions",
      "acknowledge_privacy": "I acknowledge the",
      "privacy_policy": "Privacy Policy",
      "comply_standards": "I agree to comply with SOR Registry standards and methodologies",
      "accurate_info": "I declare that all information provided is accurate and complete",
      "legal_authority": "I have the legal authority to register on behalf of this organization"
    },
    "payment_info": {
      "title": "Payment Information",
      "registration_fee_info": "Registration fee of $1,000.00 is required to complete registration",
      "fee_includes": "Fee includes account setup, initial project consultation, and ongoing support",
      "payment_methods": "Accepted payment methods: Credit card, bank transfer, cryptocurrency"
    },
    "form_actions": {
      "submit_registration": "Submit Registration ($1,000.00)",
      "cancel": "Cancel",
      "back_to_portal": "Back to Portal",
      "save_draft": "Save Draft",
      "submit_pay": "Submit & Pay $1,000.00"
    },
    "form_fields": {
      "organization_info": "Organization Information",
      "full_name_org": "Full Name / Organization Name",
      "full_name_org_placeholder": "Enter organization name",
      "business_registration_number": "Business/Company Registration Number",
      "business_registration_placeholder": "e.g., ABN, EIN, Company Number, VAT Number",
      "legal_status": "Legal Status",
      "select_legal_status": "Select legal status",
      "corporation": "Corporation",
      "llc": "Limited Liability Company",
      "partnership": "Partnership",
      "non_profit": "Non-Profit Organization",
      "government_entity": "Government Entity",
      "country_incorporation": "Country of Incorporation",
      "select_country": "Select country",
      "united_states": "United States",
      "united_kingdom": "United Kingdom",
      "canada": "Canada",
      "germany": "Germany",
      "france": "France",
      "other": "Other",
      "contact_information": "Contact Information",
      "physical_address": "Physical Address",
      "physical_address_placeholder": "Enter complete physical address",
      "contact_email": "Contact Email",
      "contact_email_placeholder": "contact{'@'}organization.com",
      "phone_number": "Phone Number",
      "phone_placeholder": "+1 (555) 123-4567",
      "local_representative": "Local Representative (if foreign entity)",
      "representative_name": "Representative Name",
      "representative_name_placeholder": "Full name",
      "representative_email": "Representative Email",
      "representative_email_placeholder": "representative{'@'}email.com",
      "declarations_terms": "Declarations & Terms",
      "accuracy_declaration": "I declare that all information provided is accurate and complete to the best of my knowledge.",
      "compliance_agreement": "I agree to comply with all SOR Registry requirements and regulations.",
      "terms_acceptance": "I have read and accept the",
      "terms_service": "Terms of Service",
      "and": "and",
      "privacy_policy": "Privacy Policy",
      "fee_acknowledgment": "I acknowledge the registration fee of $1,000.00 and any applicable maintenance fees."
    },
    "info_boxes": {
      "what_happens_next": {
        "title": "What happens next?",
        "review_time": "Application review within 5-7 business days",
        "din_generation": "Developer Identification Number (DIN) generation",
        "email_verification": "Email verification and MFA setup",
        "portal_access": "Access to project submission portal"
      },
      "secure_compliant": {
        "title": "Secure & Compliant",
        "encryption": "End-to-end encryption for all uploads",
        "gdpr_compliant": "GDPR and data protection compliant",
        "audit_trail": "Audit trail for all transactions",
        "security_monitoring": "24/7 security monitoring"
      }
    }
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "project_ideas": "Project Ideas",
    "design_documents": "Design Documents",
    "monitoring_reports": "Monitoring & Reports",
    "credit_issuance": "Credit Issuance",
    "browse_registry": "Browse Registry",
    "legacy_projects": "Legacy Projects",
    "help_support": "Help & Support",
    "settings": "Settings",
    "logout": "Logout"
  },
  "project": {
    "submit_pin": {
      "title": "Submit Project Idea Note (PIN)",
      "subtitle": "Provide initial project details for evaluation and Letter of No Objection (LNO) processing.",
      "submission_fee": "Submission Fee: $500.00",
      "review_sla": "30-day SLA for review",
      "auto_categorized": "Auto-categorized upon submission",
      "developer_id": "Developer ID",
      "save_draft": "Save as Draft",
      "project_details": {
        "title": "Project Details",
        "project_name": "Project Name",
        "project_name_placeholder": "Enter project name",
        "project_type": "Project Type",
        "select_type": "Select project type",
        "project_summary": "Project Summary",
        "project_summary_placeholder": "Provide a comprehensive overview of the project including objectives, methodology, and expected outcomes",
        "project_scope": "Project Scope and Boundaries",
        "project_scope_placeholder": "Define the physical and temporal boundaries of the project",
        "types": {
          "afforestation": "Afforestation/Reforestation",
          "forest_management": "Forest Management",
          "renewable_energy": "Renewable Energy",
          "energy_efficiency": "Energy Efficiency",
          "waste_management": "Waste Management",
          "agriculture": "Agriculture"
        }
      },
      "location": {
        "title": "Location & Geographic Information",
        "country": "Country",
        "select_country": "Select country",
        "state_province": "State/Province",
        "state_province_placeholder": "Enter state or province",
        "location_description": "Detailed Location Description",
        "location_description_placeholder": "Provide detailed location information including nearest cities, landmarks, or geographic features",
        "gps_latitude": "GPS Coordinates (Latitude)",
        "gps_latitude_placeholder": "e.g., 40.7128",
        "gps_longitude": "GPS Coordinates (Longitude)",
        "gps_longitude_placeholder": "e.g., -74.0060",
        "interactive_map": "Interactive GIS Map will appear here",
        "upload_kml": "Upload KML/Shapefile"
      },
      "emissions": {
        "title": "Emission Reduction Estimates",
        "annual_reduction": "Annual Emission Reduction (tCO2e)",
        "project_duration": "Project Duration (years)",
        "total_reduction": "Total Estimated Reduction (tCO2e)",
        "auto_calculated": "Auto-calculated",
        "methodology": "Methodology and Calculation Approach",
        "methodology_placeholder": "Describe the methodology used for emission reduction calculations"
      },
      "uploads": {
        "title": "Required Document Uploads",
        "npramp": "Non-Permanence Risk Assessment and Mitigation Plan (NPRAMP)",
        "ehmf": "Environmental Harm Management Form (EHMF)",
        "spcp": "Stakeholder and Public Consultation Plan (SPCP)",
        "fpic": "Free, Prior and Informed Consent (FPIC)",
        "financial": "Preliminary Financial Proposal",
        "required": "Required",
        "upload_text": "Click to upload or drag and drop",
        "file_types_doc": "PDF, DOC, DOCX up to 10MB",
        "file_types_finance": "PDF, XLS, XLSX up to 10MB"
      },
      "declarations": {
        "title": "Declarations & Confirmations",
        "accurate_info": "I confirm that all information provided is accurate and complete to the best of my knowledge.",
        "false_info_penalty": "I understand that submission of false or misleading information may result in rejection and potential penalties.",
        "fee_agreement": "I agree to the PIN submission fee of $500.00 and understand it is non-refundable regardless of the outcome.",
        "review_period": "I acknowledge the 30-day review period and agree to provide additional information if requested."
      },
      "actions": {
        "save_draft": "Save Draft",
        "preview": "Preview",
        "submission_fee_label": "Submission Fee:",
        "payment_processed": "Payment processed upon submission",
        "submit_pin": "Submit PIN"
      }
    },
    "submit_pdd": {
      "breadcrumb": {
        "dashboard": "Dashboard",
        "projects": "Projects",
        "submit_pdd": "Submit PDD"
      },
      "title": "Submit Project Design Document",
      "subtitle": "Complete your PDD submission with auto-filled information from your approved PIN",
      "status_draft": "Draft",
      "project_info": {
        "title": "Project Information",
        "auto_filled": "Auto-filled from approved PIN",
        "auto_filled_description": "The following information has been automatically populated from your approved Project Idea Note (PIN-2024-001).",
        "project_title": "Project Title",
        "project_category": "Project Category",
        "location": "Location",
        "estimated_credits": "Estimated Credits (tCO2e)",
        "developer_id": "Developer ID",
        "pin_reference": "PIN Reference",
        "submission_date": "Submission Date"
      },
      "doe_selection": {
        "title": "Designated Operational Entity (DOE)",
        "required_message": "DOE Selection Required",
        "description": "Select a qualified DOE for your project sector. The system will automatically check for conflicts of interest.",
        "project_sector": "Project Sector",
        "select_doe": "Select DOE *",
        "choose_doe_placeholder": "Choose a DOE...",
        "doe_options": {
          "ecoverify": "EcoVerify International - Forestry Specialist",
          "carbon_audit": "Carbon Audit Solutions - AFOLU Certified",
          "green_validation": "Green Validation Corp - Multi-Sector",
          "forest_carbon": "Forest Carbon Assessors - REDD+ Expert"
        },
        "conflict_check": {
          "title": "Conflict of Interest Check",
          "description": "System will automatically verify no conflicts exist between your organization and the selected DOE."
        }
      },
      "documents": {
        "title": "Required Documents",
        "positive_validation_report": {
          "title": "Positive Validation Report",
          "description": "From selected DOE"
        },
        "required_status": "Required",
        "upload_text": "Drop files here or click to browse",
        "choose_file": "Choose File",
        "updated_npramp": {
          "title": "Updated NPRAMP",
          "description": "Non-Permanence Risk Assessment"
        },
        "auto_filled_status": "Auto-filled",
        "updated_ehmf": {
          "title": "Updated EHMF",
          "description": "Environmental Harm Management"
        },
        "long_term_financial_proposal": {
          "title": "Long-term Financial Proposal",
          "description": "Detailed financial projections"
        }
      },
      "actions": {
        "save_draft": "Save Draft",
        "preview": "Preview",
        "cancel": "Cancel",
        "submit_pdd": "Submit PDD ($1,500)"
      },
      "sidebar": {
        "progress_card": {
          "title": "Submission Progress",
          "pin_approved": {
            "title": "PIN Approved"
          },
          "pdd_submission": {
            "title": "PDD Submission",
            "status": "In Progress"
          },
          "doe_validation": {
            "title": "DOE Validation",
            "status": "Pending"
          }
        },
        "timeline_card": {
          "title": "Important Deadlines",
          "pdd_deadline": {
            "title": "PDD Deadline",
            "description": "18 months from LNO"
          },
          "doe_selection": {
            "title": "DOE Selection",
            "description": "Within 30 days"
          }
        },
        "help_card": {
          "title": "Need Help?",
          "description": "Get assistance with your PDD submission",
          "contact_support": "Contact Support",
          "view_guide": "View Guide"
        }
      }
    }
  },
  "upload_reports": {
    "breadcrumb": {
      "dashboard": "Dashboard",
      "project_management": "Project Management",
      "monitoring_reporting": "Monitoring & Reporting"
    },
    "title": "Upload Monitoring Reports",
    "subtitle": "Submit required monitoring and compliance reports for your approved projects",
    "project_id": "Project ID",
    "project_name": "Forest Conservation Beta",
    "progress": {
      "project_registered": "Project Registered",
      "upload_reports": "Upload Reports",
      "verification": "Verification",
      "credit_issuance": "Credit Issuance",
      "next_deadline": "Next deadline:"
    },
    "required_documents_title": "Required Monitoring Documents",
    "rmr": {
      "title": "Regular Monitoring Report (RMR)",
      "description": "Submit quarterly monitoring data including emission reductions, project activities, and environmental impacts.",
      "drop_text": "Drop your RMR file here"
    },
    "required_documents": {
      "rmr": {
        "browse_text": "or click to browse files"
      },
      "sdr": {
        "title": "Sustainable Development Report (SDR)",
        "description": "Document contribution to sustainable development goals and community benefits.",
        "drop_text": "Drop your SDR file here"
      },
      "verification": {
        "title": "Third-party Verification Report",
        "description": "Independent verification report by an accredited DOE for credit issuance.",
        "drop_text": "Drop verification report here"
      },
      "reversal": {
        "title": "Reversal Event Report",
        "description": "Required only if emission reversals have occurred. Document any unintended GHG increases.",
        "drop_text": "Drop reversal event documentation here",
        "only_if_applicable": "Only if applicable"
      },
      "browse_files": "Browse Files",
      "file_support": "Supported: PDF, DOC, DOCX (Max 25MB)"
    },
    "status_labels": {
      "required": "Required",
      "optional": "Optional",
      "conditional": "Conditional",
      "submitted": "Submitted",
      "approved": "Approved",
      "pending": "Pending"
    },
    "confirmation": {
      "title": "I confirm that all uploaded documents are accurate and complete",
      "save_draft": "Save Draft",
      "submit_reports": "Submit Reports"
    },
    "guidelines": {
      "title": "Upload Guidelines",
      "english_translations": "All documents must be in English or include certified translations",
      "naming_convention": "Files should be named with project ID and document type",
      "max_file_size": "Maximum file size: 25MB per document",
      "digital_signatures": "Digital signatures required for verification reports"
    },
    "submission_status": {
      "title": "Submission Status"
    },
    "help": {
      "title": "Need Help?",
      "subtitle": "Access templates and guidelines for monitoring reports",
      "rmr_template": "RMR Template",
      "sdr_guidelines": "SDR Guidelines",
      "contact_support": "Contact Support"
    },
    "sample_data": {
      "deadline_date": "Dec 31, 2024",
      "rmr_q3_2024": "RMR Q3 2024",
      "sdr_2024": "SDR 2024",
      "rmr_q4_2024": "RMR Q4 2024"
    }
  },
  "legacy_registration": {
    "title": "Legacy Project Registration",
    "subtitle": "Register existing projects from other standards (ICS, CDM, VCS) to the SOR Registry",
    "standards": {
      "ics_migration": "ICS Migration",
      "cdm_transition": "CDM Transition",
      "vcs_compliance": "VCS Compliance"
    },
    "registration_form": {
      "title": "Legacy Registration Form",
      "subtitle": "Complete all required fields and upload necessary documentation for legacy project registration",
      "project_identification": {
        "title": "Project Information",
        "project_name": "Project Name*",
        "project_name_placeholder": "Enter full project name",
        "project_type": "Project Category*",
        "previous_standard": "Previous Standard*",
        "project_location": "Project Location*",
        "project_description": "Project Description*"
      },
      "project_details": {
        "select_category": "Select Category",
        "category_1": "Category 1 - Large Scale",
        "category_2": "Category 2 - Medium Scale",
        "category_3": "Category 3 - Small Scale",
        "select_previous_standard": "Select Previous Standard",
        "ics_standard": "ICS (International Carbon Standard)",
        "cdm_standard": "CDM (Clean Development Mechanism)",
        "vcs_standard": "VCS (Verified Carbon Standard)",
        "other_standard": "Other",
        "location_placeholder": "Country, Region",
        "description_placeholder": "Provide detailed project description"
      },
      "document_uploads": {
        "title": "Required Documentation",
        "core_documents": "Core Project Documents",
        "compliance_documents": "Compliance Documents",
        "pin": {
          "title": "Project Idea Note (PIN)*",
          "description": "Initial project concept document"
        },
        "pdd": {
          "title": "Project Design Document (PDD)*",
          "description": "Detailed project design and methodology"
        },
        "doe_validation": {
          "title": "DOE Validation Report*",
          "description": "Third-party validation report"
        },
        "npramp": {
          "title": "NPRAMP*",
          "description": "Non-Permanence Risk Assessment"
        },
        "ehmf": {
          "title": "EHMF*",
          "description": "Environmental Harm Management"
        },
        "spcp_fpic": {
          "title": "SPCP & FPIC*",
          "description": "Stakeholder Consultation & FPIC"
        },
        "crediting_proof": {
          "title": "ICS Crediting Proof / Previous Standard Certificates*",
          "description": "Upload proof of previous crediting or certificates"
        },
        "financial_proposal": {
          "title": "Financial Proposal*",
          "description": "Upload financial proposal document"
        },
        "upload_text": "Click to upload or drag and drop",
        "file_formats": {
          "pdf_doc_10mb": "PDF, DOC (Max 10MB)",
          "pdf_doc_5mb": "PDF, DOC (Max 5MB)",
          "pdf_10mb": "PDF (Max 10MB)"
        }
      },
      "financial_info": {
        "title": "Financial Information",
        "application_fee": "Application Fee: $500.00",
        "fee_description": "This fee covers the compliance review process for legacy project registration."
      },
      "declarations": {
        "title": "Declarations & Confirmations",
        "accurate_documents": "I confirm that all uploaded documents are accurate and complete to the best of my knowledge.",
        "compliance_review": "I understand that the project will undergo compliance review and may require additional documentation.",
        "fee_agreement": "I agree to pay the application fee of $500.00 upon submission.",
        "terms_acceptance": "I accept the terms and conditions of the SOR Registry and compliance procedures."
      },
      "form_actions": {
        "save_draft": "Save Draft",
        "cancel": "Cancel",
        "submit_pay": "Submit & Pay $500.00"
      }
    }
  }
}